import React from 'react';

function PageHeader({ title, subtitle, actions }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 18, flexWrap: 'wrap', marginBottom: 22 }}>
      <div style={{ minWidth: 0 }}>
        <h1 style={{ margin: 0, fontSize: 32, fontWeight: 700, lineHeight: 1.1 }}>{title}</h1>
        {subtitle ? (
          <p style={{ margin: '10px 0 0', color: '#aab7cf', maxWidth: 760, lineHeight: 1.6 }}>{subtitle}</p>
        ) : null}
      </div>
      {actions ? <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>{actions}</div> : null}
    </div>
  );
}

export default PageHeader;
